/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ base: NonNullable<unknown>, months: NonNullable<unknown> }} Admin_Billing_Batch_Detail_Months_No_DiscountInputs */

const es_admin_billing_batch_detail_months_no_discount = /** @type {(inputs: Admin_Billing_Batch_Detail_Months_No_DiscountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Base: ${i?.base} × ${i?.months} meses`)
};

const en_admin_billing_batch_detail_months_no_discount = /** @type {(inputs: Admin_Billing_Batch_Detail_Months_No_DiscountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Base: ${i?.base} × ${i?.months} months`)
};

/**
* | output |
* | --- |
* | "Base: {base} × {months} months" |
*
* @param {Admin_Billing_Batch_Detail_Months_No_DiscountInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_billing_batch_detail_months_no_discount = /** @type {((inputs: Admin_Billing_Batch_Detail_Months_No_DiscountInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Batch_Detail_Months_No_DiscountInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_billing_batch_detail_months_no_discount(inputs)
	return en_admin_billing_batch_detail_months_no_discount(inputs)
});
export { admin_billing_batch_detail_months_no_discount as "admin.billing.batch.detail_months_no_discount" }